/**
 * AuthContext — thin shim over Zustand authStore.
 * All existing pages using useAuth() continue to work unchanged.
 * New code can import useAuthStore directly from '../store/authStore'.
 */
import React, { useEffect } from 'react';
import { useAuthStore, MANAGER_ROLES, OPERATOR_ROLES } from '../store/authStore';

// Re-export role groups so existing imports don't break
export { MANAGER_ROLES, OPERATOR_ROLES };

export const AuthProvider = ({ children }) => {
  const init = useAuthStore(s => s.init);

  useEffect(() => {
    init();
  }, [init]);

  return <>{children}</>;
};

// Drop-in replacement for useAuth() — returns same shape as before
export const useAuth = () => {
  const store = useAuthStore();
  return {
    user:        store.user,
    loading:     store.loading,
    login:       store.login,
    logout:      store.logout,
    hasRole:     store.hasRole,
    hasPermission: store.hasPermission,
    homeRoute:   ROLE_HOME[store.user?.role] || '/tickets',
    refreshUser: store.refreshUser,
  };
};

// Keep ROLE_HOME export for any direct imports
export const ROLE_HOME = {
  admin:            '/home',
  ict_manager:      '/home',
  jr_engineer:      '/home',
  sr_engineer:      '/home',
  employee_manager: '/home',
  employee:         '/home',
  dashboard_viewer: '/home',
};
